.introSection {
  background-color: #f9f9f9;
  padding: 72px 0;
  text-align: center;
}

.introContainer,
.contentContainer,
.faqContainer,
.closingContainer {
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 24px;
}

.introContainer {
  max-width: 850px;
}

.contentSection {
  background-color: white;
}

.contentContainer {
  padding-top: 64px;
  padding-bottom: 64px;
}

.introHeading,
.faqHeading {
  color: #3caeb0;
  font-size: 36px;
  line-height: 1.1;
  font-weight: 700;
}

.sectionHeading {
  color: #3caeb0;
  font-size: 30px;
  line-height: 1.12;
  font-weight: 700;
}

.subheading {
  color: #3caeb0;
  font-size: 24px;
  line-height: 1.15;
  font-weight: 700;
}

.paragraph {
  line-height: 1.8;
  letter-spacing: normal;
  text-wrap: pretty;
}

.link {
  color: #3caeb0;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.link:hover {
  color: #2b8e90;
}

.inlineImage {
  display: block;
  width: 100%;
  max-width: 760px;
  height: auto;
  margin: 8px auto 0;
}

.list {
  margin: 0;
  padding-left: 1.35em;
  line-height: 1.8;
}

.list li + li {
  margin-top: 8px;
}

.faqSection {
  background-color: #e7f4f5;
  padding: 64px 0;
}

.faqHeading {
  margin-bottom: 40px;
  text-align: center;
}

.faqItem {
  background-color: white;
  border-radius: 8px;
  margin-bottom: 20px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.faqQuestion {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  padding: 24px;
  color: #3caeb0;
  font-family: inherit;
  font-size: 22px;
  line-height: 1.2;
  font-weight: 600;
}

.faqAnswer {
  height: 0;
  overflow: hidden;
  transition: height 0.3s ease;
  padding: 0 24px;
}

.faqAnswerOpen {
  height: auto;
  padding: 0 24px 24px;
}

.faqPlusIcon {
  display: inline-block;
  width: 28px;
  height: 28px;
  flex: 0 0 auto;
  font-size: 28px;
  line-height: 24px;
  text-align: center;
  transition: transform 0.3s ease;
}

.faqPlusIconOpen {
  transform: rotate(45deg);
}

.closingSection {
  background-color: #f9f9f9;
  padding: 64px 0;
}

.closingContainer {
  max-width: 900px;
  text-align: center;
}

.closingHeading {
  color: #3caeb0;
  font-size: 28px;
  line-height: 1.18;
  font-weight: 700;
}

.form {
  padding: 48px 0;
}

@media (min-width: 768px) {
  .introSection {
    padding: 126px 0;
  }

  .contentContainer {
    padding-top: 90px;
    padding-bottom: 90px;
  }

  .introHeading,
  .faqHeading {
    font-size: 50px;
  }

  .sectionHeading {
    font-size: 38px;
  }

  .subheading {
    font-size: 28px;
  }

  .closingHeading {
    font-size: 34px;
  }

  .form {
    padding: 96px 20px;
  }
}
